export const knobRadius = 10

export const knobSize = { width: knobRadius * 2, height: knobRadius * 2 }

export const slideSize = { width: 34, height: 14 }

export const slideVisibleHorizontalOffset = 1

const knobOverSlideHorizontalOverhang = 2

export const knobVerticalOffset = 1

export const uncheckedKnobLeftOffset = 0
export const checkedKnobLeftOffset = 16

export const switchSize = {
    width: slideSize.width + slideVisibleHorizontalOffset + knobOverSlideHorizontalOverhang,
    height: knobSize.height + knobVerticalOffset * 2,
}

export const animationDurationMs = 150
